(() => {
  'use strict';
  function initHeader(root = document) {
    const button = root.querySelector('[data-menu-toggle]');
    const navigation = root.querySelector('[data-navigation]');
    if (!button || !navigation || button.dataset.initialized) return;
    button.dataset.initialized = 'true';
    function close() {
      navigation.classList.remove('is-open');
      button.setAttribute('aria-expanded', 'false');
      button.setAttribute('aria-label', 'Open navigation');
      document.body.classList.remove('sv-menu-open');
    }
    button.addEventListener('click', () => {
      const opened = button.getAttribute('aria-expanded') !== 'true';
      navigation.classList.toggle('is-open', opened);
      button.setAttribute('aria-expanded', String(opened));
      button.setAttribute('aria-label', opened ? 'Close navigation' : 'Open navigation');
      document.body.classList.toggle('sv-menu-open', opened);
    });
    navigation.addEventListener('click', (event) => {
      if (event.target.closest('a')) close();
    });
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && button.getAttribute('aria-expanded') === 'true') {
        close();
        button.focus();
      }
      if (event.key === 'Tab' && button.getAttribute('aria-expanded') === 'true') {
        const links = [button, ...navigation.querySelectorAll('a, summary')].filter((el) => el.offsetParent !== null);
        const first = links[0];
        const last = links[links.length - 1];
        if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
        else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
      }
    });
    window.matchMedia('(min-width: 901px)').addEventListener('change', close);
  }
  function initAutoSubmit(root = document) {
    root.querySelectorAll('[data-auto-submit]').forEach((control) => {
      if (control.dataset.initialized) return;
      control.dataset.initialized = 'true';
      control.addEventListener('change', () => control.form?.requestSubmit());
    });
  }
  function init(root = document) { initHeader(root); initAutoSubmit(root); }
  init();
  document.addEventListener('shopify:section:load', (event) => init(event.target));
  document.addEventListener('shopify:section:unload', () => document.body.classList.remove('sv-menu-open'));
})();
